import MainLayout from '@/components/layout/MainLayout'
import { lazy, Suspense, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { initializeAppColors } from '@/lib/colorUtils'
import { initLiquidReflect } from '@/lib/liquidReflectUtils'
import useUIStore from '@/store/useUIStore'

// Dynamically import LiquidBackground
const LiquidBackground = lazy(() =>
  import('@/components/ui/LiquidBackground').then(mod => ({
    default: mod.LiquidBackground
  }))
)

// Loading fallback component
const LoadingFallback = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-[rgb(10,10,10)] bg-opacity-90 z-50">
    <div className="animate-pulse text-white text-lg">Loading...</div>
  </div>
)

export default function Layout() {
  const backgroundColor = useUIStore((state) => state.backgroundColor);

  // Initialize colors and liquid reflect when the component mounts
  useEffect(() => {
    initializeAppColors()
    initLiquidReflect()
  }, [])

  return (
    <Suspense fallback={<LoadingFallback />}>
      <MainLayout>
        <Outlet />
      </MainLayout>

      {/* Dark background for all pages */}
      <div
        className='fixed inset-0 -z-10 w-screen h-screen bg-[rgb(10,10,10)] backdrop-blur-xs'
        style={{ backgroundColor: 'rgb(10, 10, 10)' }}
        aria-hidden='true'
      />

      {/* Liquid background for all pages */}
      <Suspense
        fallback={
          <div
            className='fixed inset-0 -z-10 w-screen h-screen bg-[rgb(10,10,10)]'
            style={{ backgroundColor: 'rgb(10, 10, 10)' }}
            aria-hidden='true'
          />
        }
      >
        <LiquidBackground key={backgroundColor} />
      </Suspense>

    </Suspense>
  )
}
